import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import PingLogo from '../logos/ping.svg';
export const GetPingCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PingCardTID: {
                Card: 'ping-card',
                Connect: 'ping-card-connect'
            }
        }
    });
export default function PingCard() {
    const { t: pingTexts } = useLocaleKeys('integrations.apps');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('ping');
    const { PingCardTID } = useMemo(()=>GetPingCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: PingCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(PingLogo, {
            width: 40,
            height: 40
        }),
        title: pingTexts.ping.title(),
        subTitle: pingTexts.ping.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_ping'
            },
            onClick: showCopyAPIKeyModal,
            testId: PingCardTID.Connect(),
            children: pingTexts.shared.connectButton()
        })
    });
}
